import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import heart from '../assets/heart.png';
import shepherd from '../assets/shepherd.webp';

export const Wrapper = styled.div`
  background-image: url(${shepherd});
  background-size: cover;
  padding: 96px;

  ${mediaQuery(BREAKPOINTS.medium)} {
    padding: 48px;
  }
  ${mediaQuery(BREAKPOINTS.phone)} {
    padding: 16px;
  }
`;

export const Content = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.light.default};
  padding: 48px;
  max-width: 50%;
  &:after {
    content: '';
    position: absolute;
    top: -24px;
    right: -24px;
    width: 48px;
    height: 48px;
    background-image: url(${heart});
    background-size: cover;
  }

  ${mediaQuery(BREAKPOINTS.medium)} {
    max-width: 100%;
    padding: 32px;
  }
`;
